import { xor } from 'lodash';
import { getServicesIds } from 'modules/queues/common/selectors/servicesIds';
import { startObserveServiceConfigUpdates } from 'modules/websocket/actions/serviceConfigUpdate';

import createAction from '.';

export const SET_SERVICES_IDS = createAction('SET_SERVICES_IDS');

export const resubscribeServiceConfigUpdates = (dispatch, getState) => {
  const state = getState();
  const { servicesIds } = state.queues.common.services;
  const newServicesIds = getServicesIds(state);

  if (xor(servicesIds, newServicesIds).length) {
    dispatch({
      type: SET_SERVICES_IDS,
      payload: { servicesIds: newServicesIds },
    });

    dispatch(startObserveServiceConfigUpdates(newServicesIds));
  }
};
